/* eslint-disable @typescript-eslint/no-explicit-any */
import { User } from 'entities';

import { env } from 'config/env';
import { trackingConfig } from './config';
import { appendPixel } from './loadScript';

export function pageView(path: string) {
  // facebook
  window.fbq?.('track', 'PageView');

  // Taboola
  window._tfa?.push({ notify: 'event', name: 'page_view', id: trackingConfig.tabolaId });

  // Twitter
  window.twq?.('track', 'PageView');

  // google
  window.gtag?.('config', trackingConfig.gtagId, { page_path: path });
}

function setPanelistContext(panelistId: string) {
  (document as any).PanelistId = panelistId;
}

function fireInsight(panelistId: string, iso: string, path: string) {
  const url = new URL('https://secure.insightexpressai.com/adserver/PanelistPartnerESI.aspx');

  url.searchParams.set('PartnerID', '147');
  url.searchParams.set('PanelistID', panelistId);
  url.searchParams.set('iso', iso);
  url.searchParams.set('redir', path);

  appendPixel(url.toString());
}

function fireVoiceFive(panelistId: string) {
  const u = new URL('https://sb.voicefive.com/p');

  u.searchParams.set('c1', '14');
  u.searchParams.set('c2', '18299462');
  u.searchParams.set('c3', panelistId);
  u.searchParams.set('c4', 'v');
  u.searchParams.set('cj', '1');

  appendPixel(u.toString());
}

function fireScorecard(panelistId: string) {
  const u = new URL('https://sb.scorecardresearch.com/p');

  u.searchParams.set('c1', '14');
  u.searchParams.set('c2', '18299462');
  u.searchParams.set('c3', panelistId);
  u.searchParams.set('c4', 's');
  u.searchParams.set('cj', '1');

  appendPixel(u.toString());
}

export function onLoggedInRoute({ id, country }: User, path: string) {
  setPanelistContext(id);

  fireInsight(id, country, path);

  const fireScores = env.appId === 'voceopina' || ['MX', 'US'].includes(country);

  if (fireScores) {
    fireVoiceFive(id);
    fireScorecard(id);
  }
}
